"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ContentCard, type ImageComponent } from "fansunited-sports-ui";
import { FillImage } from "@/components/ui/FillImage";
import { MediaVariantsProvider } from "@/components/ui/MediaVariantsProvider";
import { getPostImageUrl } from "@/components/ui/PostImage";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { Post } from "@/payload-types";
export interface ArticlePairProps {
  /** Two featured articles */
  articles: Post[];
}

/**
 * ArticlePair - Two large article cards side by side for featured content.
 * Used between the goals section and promotional content.
 */
export const ArticlePair: React.FC<ArticlePairProps> = t0 => {
  const $ = _c(15);
  const {
    articles
  } = t0;
  const nav = useNavigation();
  if (articles.length === 0) {
    return null;
  }
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== articles || $[1] !== nav) {
    const displayArticles = articles.slice(0, 2);
    T0 = MediaVariantsProvider;
    t3 = displayArticles.map(_temp);
    t1 = "grid grid-cols-1 md:grid-cols-2 gap-4";
    let t4;
    if ($[6] !== nav) {
      t4 = article => <ContentCard key={article.id} content={{
        id: String(article.id),
        type: article.type === "video" ? "video" : "article",
        link: nav.post(article),
        title: article.title,
        description: article.summary || undefined,
        image: {
          url: getPostImageUrl(article, "large"),
          alt: article.title
        },
        gradient: "linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.5) 40%, transparent 70%)"
      }} variant="standard" ImageComponent={FillImage as ImageComponent} styles={{
        shadow: "none",
        borderRadius: "lg",
        typography: {
          title: "text-lg md:text-xl font-bold mb-1!",
          description: "text-xs md:text-sm text-white/70 line-clamp-2"
        }
      }} />;
      $[6] = nav;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t2 = displayArticles.map(t4);
    $[0] = articles;
    $[1] = nav;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4) {
    t5 = <section><T0 media={t3}>{t4}</T0></section>;
    $[11] = T0;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(post) {
  return post.heroImage;
}